/**
 * Map a GM image filename to a language slot.
 * Expected codes in the name (case-insensitive tokens):
 *   en → English
 *   hn / hi → Hindi
 *   mr → Marathi
 *   gj / gu → Gujarati
 *
 * Matches whole tokens split on non-alphanumeric characters
 * (e.g. gm_en_2026.jpg, morning-hn.png, photo.mr.webp).
 */
const CODE_TO_LANG = {
  en: 'en',
  hn: 'hi',
  hi: 'hi',
  mr: 'mr',
  gj: 'gu',
  gu: 'gu'
};

export function detectLangFromFilename(filename) {
  if (!filename || typeof filename !== 'string') return null;

  const base = filename.toLowerCase().replace(/\.[^.]+$/, '');
  const tokens = base.split(/[^a-z0-9]+/).filter(Boolean);

  for (const token of tokens) {
    if (CODE_TO_LANG[token]) return CODE_TO_LANG[token];
  }

  // Fallback: code surrounded by non-alphanumeric boundaries
  for (const [code, lang] of Object.entries(CODE_TO_LANG)) {
    const re = new RegExp(`(?:^|[^a-z0-9])${code}(?:[^a-z0-9]|$)`);
    if (re.test(base)) return lang;
  }

  return null;
}

export function readFileAsDataURL(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(new Error(`Failed to read ${file.name}`));
    reader.readAsDataURL(file);
  });
}
